import { timeOptions } from "../../config/schedule";

export function TimeSelect({ value, disabled, onChange }: { value: string; disabled?: boolean; onChange: (value: string) => void }) {
  return (
    <select className="time-select" value={value} disabled={disabled} onChange={(event) => onChange(event.target.value)}>
      {timeOptions.map((time) => (
        <option key={time} value={time}>
          {time}
        </option>
      ))}
    </select>
  );
}
